import { Ref, useCallback, useImperativeHandle, useRef } from "react";
import {
    GestureResponderEvent,
    MeasureInWindowOnSuccessCallback,
    Pressable,
    PressableProps,
    View,
} from "react-native";

type PressableWithFocusRef = {
    focus: (e: GestureResponderEvent) => void;
};

export const PressableWithFocus = ({
    ref,
    ...props
}: PressableProps & { ref?: Ref<PressableWithFocusRef> }) => {
    const pressableRef = useRef<View>(null);

    const focus = useCallback(
        (e: GestureResponderEvent) => {
            props.onPress?.(e);
        },
        [props],
    );

    useImperativeHandle(ref, () => {
        const handle = {
            measureInWindow: (callback: MeasureInWindowOnSuccessCallback) =>
                pressableRef.current?.measureInWindow?.(callback),
            focus,
        };

        // Si ref est une fonction callback, l'appeler avec le handle
        if (typeof ref === "function") {
            ref(handle);
        }

        return handle;
    }, [ref, focus]);

    return <Pressable ref={pressableRef} {...props} />;
};
